import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_ANAGRAFICA_CATEGORIA } from '../../data.const';
import {
  retrieveAnagraficaCategoriaAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deleteAnagraficaCategoriaEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_ANAGRAFICA_CATEGORIA),
    map(({ payload: { ids, ...rest } }: any) => ({
      body: {
        ids,
      },
      listBody: rest,
    })),
    // tap(p => console.log(`[epic ${DELETE_ANAGRAFICA_CATEGORIA}]`, p)),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ anagraficaLoader: true })),
        defer(() =>
          from(
            request({
              path: `anagraficaCategoria`,
              method: httpMethods.DELETE,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            switchMap(() => of(retrieveAnagraficaCategoriaAction(null))),
            catchError(err => {
              console.error(`[epic ${DELETE_ANAGRAFICA_CATEGORIA}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ anagraficaLoader: false }))
      );
    })
  );

export default deleteAnagraficaCategoriaEpic;
